import { DEFAULT_BOOKING_ACCENT } from './booking-branding.constants';

const LONG_HEX_PATTERN = /^[0-9A-F]{6}$/;
const SHORT_HEX_PATTERN = /^[0-9A-F]{3}$/;

export interface NormalizeAccentInputOptions {
  /** `RGB` short form: the settings card only; the server rejects it. */
  allowShort: boolean;
}

export type NormalizedAccentInput =
  | { value: string | null }
  | { error: 'invalid_hex' };

/** Uppercase `#RRGGBB`, or `null` for empty and for the product default. */
export function normalizeAccentInput(
  raw: string,
  { allowShort }: NormalizeAccentInputOptions,
): NormalizedAccentInput {
  const digits = raw.trim().replace(/^#/, '').toUpperCase();
  if (digits === '') return { value: null };

  const expanded =
    allowShort && SHORT_HEX_PATTERN.test(digits)
      ? digits.replace(/./g, (digit) => digit + digit)
      : digits;
  if (!LONG_HEX_PATTERN.test(expanded)) return { error: 'invalid_hex' };

  const value = `#${expanded}`;
  return { value: value === DEFAULT_BOOKING_ACCENT ? null : value };
}
